import type { PartialStoreState } from '../typings'

export const selectPlaces = (state: PartialStoreState) =>
  state.domain.publicData.domain.gps.wwgps.places
